import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  Box,
  SubHeadingStyled,
  DataContainerHeader,
  ThemeLoader,
} from "../../../components/styled/Elements";
import { SettingsWrapper, FormDataContainer } from "./styled";
import { useNavigate } from "react-router-dom";
import {
  establishmentContact,
  establishmentInit,
  establishmentLocation,
  establishmentUploads,
} from "../../../helpers/dummyConstants";
import ViewPage from "../../../components/common/pageView/pageView";
import { Edit } from "../../../components/styled/AllImages";
import ListTable from "../../../components/common/tables/ListTable";
import {
  branchesColumns,
  headquartersColumns,
} from "../../../helpers/adminConstants/TableConstants";
import EstablishmentApi from "../../../services/api/establishmentApi";
import { useUser } from "../../../context/userContext";

const Establishment = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();
  const { user } = useUser();
  const [estInit, setEstInit] = useState(establishmentInit);
  const [estLocation, setEstLocation] = useState(establishmentLocation);
  const [estContact, setEstContact] = useState(establishmentContact);
  const [estUploads, setEstUploads] = useState(establishmentUploads);
  const [branchesRows, setBranchesRows] = useState([]);
  const [headquartersRows, setHeadquartersRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    try {
      setLoading(true);
      const response = await EstablishmentApi.establishment();
      if (response?.data) {
        const updatedEstInit = establishmentInit.map((item) => {
          const key = item.label; // Match the label with the key in the API response
          let updatedText;
          if (key === "type") {
            updatedText = response?.data?.oragnization_type?.name;
          }
          if (key === "Sector") {
            updatedText = response?.data?.sector;
          }
          if (key === "name") {
            updatedText = response?.data?.organization_name;
          }
          if (key === "Description") {
            updatedText = response?.data?.description;
          }
          return { ...item, text: updatedText };
        });
        setEstInit(updatedEstInit);

        const updatedEstLocation = establishmentLocation.map((item) => {
          const key = item.label; // Match the label with the key in the API response
          let updatedText;
          if (key === "Country") {
            updatedText = response?.data?.country?.name;
          }
          if (key === "City") {
            updatedText = response?.data?.country?.city;
          }
          if (key === "Address") {
            updatedText = response?.data?.address;
          }
          return { ...item, text: updatedText };
        });
        setEstLocation(updatedEstLocation);

        const updatedEstContact = establishmentContact.map((item) => {
          const key = item.label; // Match the label with the key in the API response
          let updatedText;
          if (key === "ContactNo") {
            updatedText = response?.data?.contact_phone;
          }
          if (key === "email") {
            updatedText = response?.data?.contact_email;
          }
          if (key === "ContactPerson") {
            updatedText = response?.data?.contact_person;
          }
          return { ...item, text: updatedText };
        });
        setEstContact(updatedEstContact);

        const baseAssetURL = process.env.REACT_APP_ASSET_URL;
        const logoUrl = response?.data?.logo
          ? `${baseAssetURL}/${response.data.logo}`
          : null;
        const updatedEstUploads = establishmentUploads.map((item) => {
          if (item.label === "Logo") {
            return {
              ...item,
              render: () => (
                <Box className="upload-image-full">
                  {logoUrl ? <img src={logoUrl} alt="Logo" /> : <span></span>}
                </Box>
              ),
            };
          }
          return item;
        });
        setEstUploads(updatedEstUploads);

        if (response?.data.branches) {
          const updatedBranchesRows = response?.data?.branches?.map(
            (branch) => ({
              key: branch.id, // Assuming each branch has a unique id
              BranchnameEN: branch.name_en || "N/A",
              BranchnameAR: branch.name_ar || "N/A",
              City:
                language === "en"
                  ? branch.city?.en_name
                  : branch.city?.ar_name || "N/A", // Assuming branch has a nested city object
            })
          );
          setBranchesRows(updatedBranchesRows);
        }

        if (response?.data?.head_quarters) {
          const updatedHeadquaeters = response?.data?.head_quarters.map(
            (headquarter) => ({
              key: headquarter.id,
              HeadquarternameEN: headquarter.name_en || "N/A",
              HeadquarternameAR: headquarter.name_ar || "N/A",
              City:
                language === "en"
                  ? headquarter.city?.en_name
                  : headquarter.city?.ar_name || "N/A" || "N/A",
            })
          );
          setHeadquartersRows(updatedHeadquaeters);
        }
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [language]);

  return (
    <SettingsWrapper>
      <Box className="content-head">
        <SubHeadingStyled size="16px" color="var(--text)">
          {t("settings")}
        </SubHeadingStyled>
      </Box>
      {loading ? (
        <ThemeLoader />
      ) : (
        <Box className="content-container">
          <Row className="mt-3">
            <Col md={12}>
              <FormDataContainer className="dataContainer">
                {user &&
                  (Number(user?.user_type_id) === 2 ||
                    user?.is_temporary_admin_director) && (
                    <DataContainerHeader
                      label={t("establishment")}
                      btnLabel="edit"
                      icon={Edit}
                      onClick={() => navigate("/settings/establishment/edit")}
                    />
                  )}
                {estInit.map((view, i) => (
                  <ViewPage
                    key={view.id}
                    label={view.label}
                    text={view.text}
                    render={view.render ? view.render : null}
                  />
                ))}
                <Box className="innerFoHead">
                  <SubHeadingStyled size="16px" color="var(--text)">
                    {t("location")}
                  </SubHeadingStyled>
                </Box>
                {estLocation.map((view, i) => (
                  <ViewPage
                    key={view.id}
                    label={view.label}
                    text={view.text}
                    render={view.render ? view.render : null}
                  />
                ))}
                <Box className="innerFoHead">
                  <SubHeadingStyled size="16px" color="var(--text)">
                    {t("ContactDetails")}
                  </SubHeadingStyled>
                </Box>
                {estContact.map((view, i) => (
                  <ViewPage
                    key={view.id}
                    label={view.label}
                    text={view.text}
                    render={view.render ? view.render : null}
                  />
                ))}
                <Box className="innerFoHead">
                  <SubHeadingStyled size="16px" color="var(--text)">
                    {t("Uploads")}
                  </SubHeadingStyled>
                </Box>
                {estUploads.map((view) => (
                  <ViewPage
                    key={view.id}
                    label={view.label}
                    text={view.text}
                    render={view.render ? view.render : null}
                  />
                ))}
                <Box className="innerFoHead">
                  <SubHeadingStyled size="16px" color="var(--text)">
                    {t("Branches")}
                  </SubHeadingStyled>
                </Box>
                <Box>
                  <ListTable
                    rows={branchesRows}
                    columns={branchesColumns}
                    className="tableSecondary"
                  />
                </Box>
                <Box className="innerFoHead">
                  <SubHeadingStyled size="16px" color="var(--text)">
                    {t("Headquarters")}
                  </SubHeadingStyled>
                </Box>
                <Box>
                  <ListTable
                    rows={headquartersRows}
                    columns={headquartersColumns}
                    className="tableSecondary"
                  />
                </Box>
              </FormDataContainer>
            </Col>
          </Row>
        </Box>
      )}
    </SettingsWrapper>
  );
};

export default Establishment;
